import { Button } from "@jhool-io/fe-components";

import { ViewEditorText } from "../../TextEditor/ViewEditorText/ViewEditorText";
import { cn } from "../../../utils/helpers";

interface NotificationProps {
    /** Details of notification */
    details: string;
    /** Title of the notification */
    title: string;
    /** How long ago the notification was sent */
    timeLaspe: string;
    /** Boolean to check if notification has been read or not */
    isUnread: boolean;
    /** Type of notification */
    type: "not_reminder" | "reminder";
    /** Function to call when notification is clicked */
    onClick?: () => void;
}

export default function Notification({
    details,
    title,
    timeLaspe,
    isUnread,
    type,
    onClick,
}: NotificationProps) {
    return (
        <div>
            <Button
                onClick={onClick}
                onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                        onClick?.();
                    }
                }}
                className="justify-start h-auto gap-y-1 relative hover:bg-transparent cursor-pointer"
                variant="can-hover"
                size="auto"
                aria-label="Notification"
            >
                <div className="flex h-auto flex-col items-start">
                    <h3 className="font-medium text-caption text-text text-left mb-1">
                        {title}
                    </h3>
                    <div className="*:!font-semibold *:!text-small *:!mb-2 *:!text-textSec *:!text-left">
                        <ViewEditorText text={details} />
                    </div>
                    <div
                        className={cn(
                            "text-[11px flex items-center gap-x-1 text-small italic",
                            {
                                "bg-[#fdf7eb]": type === "reminder",
                            }
                        )}
                    >
                        {timeLaspe ? (
                            <>
                                <svg
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="size-3"
                                >
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="12 6 12 12 16 14" />
                                </svg>
                                <span className="">{timeLaspe}</span>
                            </>
                        ) : null}
                    </div>
                </div>
                <div
                    className={cn(
                        "absolute left-0 top-0 h-full w-1 bg-stroke rounded-md",
                        {
                            "bg-primary": isUnread,
                            "bg-[#fdf7eb]": type === "reminder",
                        }
                    )}
                />
            </Button>
        </div>
    );
}
